<div [formGroup]="form">
  <div *ngIf="indexRow !== null" [formArrayName]="keyformArrayName">
    <div [formGroupName]="indexRow">
      <mat-label class="label-form">{{ meta.label }}:</mat-label>
      <mat-form-field
        [ngClass]="control.invalid && submitted ? 'invalid-field' : ''"
        appearance="fill"
        class="date-input w-full"
      >
        <mat-label>Scegli una data</mat-label>
        <input
          (dateChange)="customActionInput($event, indexRow)"
          *ngIf="meta.maxDateToday"
          [formControlName]="meta.key"
          [matDatepicker]="picker"
          [max]="today"
          matInput
          placeholder="DD/MM/YYYY"
        />
        <input
          (dateChange)="customActionInput($event, indexRow)"
          *ngIf="meta.minDateToday"
          [formControlName]="meta.key"
          [matDatepicker]="picker"
          [min]="today"
          matInput
          placeholder="DD/MM/YYYY"
        />
        <input
          (dateChange)="customActionInput($event, indexRow)"
          *ngIf="!meta.maxDateToday && !meta.minDateToday"
          [formControlName]="meta.key"
          [matDatepicker]="picker"
          matInput
          placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="indexRow === null">
    <mat-label class="label-form">{{ meta.label }}:</mat-label>
    <mat-form-field
      [ngClass]="control.invalid && submitted ? 'invalid-field' : ''"
      appearance="fill"
      class="date-input w-full"
    >
      <mat-label>Scegli una data</mat-label>
      <input
        (dateChange)="customActionInput($event)"
        *ngIf="meta.maxDateToday"
        [formControlName]="meta.key"
        [matDatepicker]="picker"
        [max]="today"
        matInput
        placeholder="DD/MM/YYYY"
      />
      <input
        (dateChange)="customActionInput($event)"
        *ngIf="!meta.maxDateToday"
        [formControlName]="meta.key"
        [matDatepicker]="picker"
        matInput
        placeholder="DD/MM/YYYY"
      />
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <app-box-errors [control]="control" [meta]="meta" [submitted]="submitted"></app-box-errors>
</div>
